import InnerDisableSalesSequenceModal from './InnerDisableSalesSequenceModal'

const DisableSalesSequenceConfirmModal = ({
  draft,
  onCloseClick,
  onDisableClick,
}) => {
  return (
    <InnerDisableSalesSequenceModal
      onCloseClick={onCloseClick}
      onDisableClick={onDisableClick}
      playbook={draft}
    />
  )
}

export default DisableSalesSequenceConfirmModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/DisableSalesSequenceConfirmModal/component.js